/**
 * Thin fetch wrapper that auto-attaches the Bearer session token.
 * All requests hit the platform-api worker at VITE_WORKER_API_URL.
 */

import { readSessionToken } from './auth';

const API_URL =
  (import.meta.env as Record<string, string>).VITE_WORKER_API_URL ||
  'https://clarity-platform-api.ryan-dc4.workers.dev';

function authHeaders(): Record<string, string> {
  const token = readSessionToken();
  return token ? { authorization: `Bearer ${token}` } : {};
}

export class AdminForbiddenError extends Error {
  constructor() {
    super('forbidden');
    this.name = 'AdminForbiddenError';
  }
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { ...authHeaders() },
  });
  if (res.status === 403) {
    throw new AdminForbiddenError();
  }
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`GET ${path} failed ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}
